import React from "react";
import { Link } from "react-router-dom";

// Image imports
import footerBg from "../../images/bg/footer-bg.png";
import locationIcon from "../../images/icon/location-icon.svg";
import callIcon from "../../images/icon/call-icon.svg";
import kotLogo from "../../images/logo/kot-logo-white.png";

const Footer: React.FC = () => {
  const arrowIcon = (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.06641"
        y="19.2783"
        width="20.5712"
        height="2.61221"
        transform="rotate(-40.2798 5.06641 19.2783)"
        fill="white"
      />
      <rect
        x="7.97144"
        y="6.54443"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 7.97144 6.54443)"
        fill="white"
      />
      <rect
        x="11.6528"
        y="6.84814"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 11.6528 6.84814)"
        fill="white"
      />
      <rect
        x="15.3345"
        y="7.15186"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 15.3345 7.15186)"
        fill="white"
      />
      <rect
        x="18.7124"
        y="11.1372"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 18.7124 11.1372)"
        fill="white"
      />
      <rect
        x="18.4089"
        y="14.8198"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 18.4089 14.8198)"
        fill="white"
      />
      <rect
        x="18.1045"
        y="18.501"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 18.1045 18.501)"
        fill="white"
      />
    </svg>
  );

  // KOT social links — Instagram, LinkedIn, WhatsApp
  const socials = [
    {
      icon: <i className="fa-brands fa-instagram"></i>,
      name: "Instagram",
      url: "https://www.instagram.com/kotglobal?igsh=YWhrbnQ5OThyOXNy",
    },
    {
      icon: <i className="fa-brands fa-linkedin"></i>,
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/kotenterprises",
    },
    {
      icon: <i className="fa-brands fa-whatsapp"></i>,
      name: "WhatsApp",
      url: "https://wa.me/923041110427",
    },
  ];

  return (
    <footer
      className="footer footer-style-one pt-145 bg_img"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="xb-footer-wrap">
        {/* Footer Navigation */}
        <div className="xb-footer-nav">
          <div className="xb-footer-nav-item">
            <span className="sub-title">Who we are?</span>
            <h2 className="title">
              <Link to="/about">About us</Link>
            </h2>
          </div>
          {/* Our ventures + Our initiatives — filhal comment (user request) */}
          {/*
          <div className="xb-footer-nav-item">
            <span className="sub-title">Our ventures</span>
            <h2 className="title">
              <Link to="#">Corporate Companies</Link>
            </h2>
          </div>
          <div className="xb-footer-nav-item">
            <span className="sub-title">Our initiatives</span>
            <h2 className="title">
              <Link to="#">Strategic Programs</Link>
            </h2>
          </div>
          */}
          {/* KOT logo — About us aur Contact us ke beech */}
          <div className="xb-footer-nav-item xb-footer-logo">
            <Link to="/">
              <img src={kotLogo} alt="KOT Enterprises" />
            </Link>
          </div>
          <div className="xb-footer-nav-item">
            <span className="sub-title">Let's talk</span>
            <h2 className="title">
              <Link to="/#contact">Contact us</Link>
            </h2>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="xb-social-media-wrap">
          {socials.map((social, idx) => (
            <div className="xb-social-media-item ul_li_between" key={idx}>
              <div className="xb-item--holder ul_li">
                <div className="xb-item--icon">{social.icon}</div>
                <span className="xb-item--name">{social.name}</span>
              </div>

              <span className="xb-item--arrow">{arrowIcon}</span>

              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name} 
                className="xb-overlay"
              ></a>
            </div>
          ))}
        </div>

        {/* Footer Bottom */}
        <div className="xb-footer-bottom">
          <div className="contact-item">
            <img src={locationIcon} alt="location" />
            <span className="contact-method">Gulberg, Lahore, Pakistan</span>
          </div>

          <div className="contact-item copyright-item">
            <p>
              Copyright © 2026 <Link to="/">KOT Enterprises (Private) Limited</Link>, All rights reserved.
            </p>
          </div>

          <div className="contact-item">
            <a href="tel:+923041110427">
              <img src={callIcon} alt="call" />
            </a>
            <a className="contact-method" href="tel:+923041110427">
              +92 304 1110427
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
